import FeeDefinition from "@/models/Products/ProductFees/FeeDefinition";
import ManualFee from '@/models/Products/ProductFees/ManualFee';
import ScheduledFee from '@/models/Products/ProductFees/ScheduledFee';
import TransactionalFee from '@/models/Products/ProductFees/TransactionalFee';

export default class FeeSettings {
    overridable: boolean = false;
    arbitraryFeesEnabled: boolean = false;
    feeDefinitions: FeeDefinition[] = [];
    manualFees: ManualFee[] = [];
    scheduledFees: ScheduledFee[] = [];
    transactionalFees: TransactionalFee[] = [];
}